import React from 'react'
import { Text, StyleSheet, StyleProp, TextStyle } from 'react-native'

interface TypographyProps {
  children: React.ReactNode
  variant: 'title' | 'heading' | 'subheading' | 'body'
  color?: string
  style?: StyleProp<TextStyle>
}

const styles = StyleSheet.create({
  general: {
    fontFamily: 'Verdana',
    color: '#000000',
  },
  // Variants
  title: {
    fontSize: 30,
    fontWeight: 'bold',
  },
  heading: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  subheading: {
    fontSize: 16,
    lineHeight: 20,
  },
  body: {
    fontSize: 14,
    lineHeight: 20,
  }
})

export const Typography: React.FC<TypographyProps> = ({ children, variant, color, style }) => {
  return (
    <Text style={[styles.general, styles[variant], { color }, style]}>
      {children}
    </Text>
  )
}